import { DamsAppAsset } from "../../assets/registry";

import appRoutePath from "../path";

export const navIcons = {
  menu: {
    active: DamsAppAsset.icons.help,
    innactive: DamsAppAsset.icons.help,
  },
  dashboard: {
    active: DamsAppAsset.icons.dashboard_green,
    innactive: DamsAppAsset.icons.dashboard,
  },
  assets: {
    active: DamsAppAsset.icons.devices_green,
    innactive: DamsAppAsset.icons.devices,
  },
  users: {
    active: DamsAppAsset.icons.users_green,
    innactive: DamsAppAsset.icons.users,
  },
  divisions: {
    active: DamsAppAsset.icons.users_green,
    innactive: DamsAppAsset.icons.users,
  },
  programmes: {
    active: DamsAppAsset.icons.programs_green,
    innactive: DamsAppAsset.icons.Programmes,
  },
  regions: {
    active: DamsAppAsset.icons.programs_green,
    innactive: DamsAppAsset.icons.Programmes,
  },
  donors: {
    active: DamsAppAsset.icons.programs_green,
    innactive: DamsAppAsset.icons.Programmes,
  },
  batches: {
    active: DamsAppAsset.icons.programs_green,
    innactive: DamsAppAsset.icons.Programmes,
  },
  districts: {
    active: DamsAppAsset.icons.programs_green,
    innactive: DamsAppAsset.icons.Programmes,
  },
  facilities: {
    active: DamsAppAsset.icons.programs_green,
    innactive: DamsAppAsset.icons.Programmes,
  },
  maintenance: {
    active: DamsAppAsset.icons.maintenance_green,
    innactive: DamsAppAsset.icons.maintenance,
  },
  roles: {
    active: DamsAppAsset.icons.roles_green,
    innactive: DamsAppAsset.icons.roles_permissions,
  },
  close: {
    active: DamsAppAsset.icons.close,
    innactive: DamsAppAsset.icons.close,
  },
  notifications: {
    active: DamsAppAsset.icons.notifications,
    innactive: DamsAppAsset.icons.notifications,
  },
  settings: {
    active: DamsAppAsset.icons.settings_green,
    innactive: DamsAppAsset.icons.settings,
  },
  more: {
    active: DamsAppAsset.icons.more,
    innactive: DamsAppAsset.icons.more,
  },
  reports: {
    active: DamsAppAsset.icons.columns,
    innactive: DamsAppAsset.icons.columns,
  },
  support: {
    active: DamsAppAsset.icons.support,
    innactive: DamsAppAsset.icons.support,
  },

  default: {
    active: DamsAppAsset.icons.devices_green,
    innactive: DamsAppAsset.icons.devices,
  },
};
export const navPages = {
  DASHBOARD: {
    HOME: {
      title: "Dashboard",
      path: appRoutePath.DASHBOARD_HOME_PAGE,
      icon: navIcons.dashboard,
    },
  },
  USER_DIRECTORY: {
    USERS_PAGE: {
      title: "Users Directory",
      path: appRoutePath.USERS_PAGE,
      icon: navIcons.users,
    },
    USERS_ROLES_PAGE: {
      title: "Roles Management",
      path: "/roles",
      icon: navIcons.roles,
    },
    USER_CHANGE_PASSWORD_PAGE: {
      title: "Change Password",
      path: appRoutePath.USER_CHANGE_PASSWORD_PAGE,
      icon: navIcons.users,
    },
  },

  ASSET_REGISTRY: {
    ADD_ASSET_REGISTRY_PAGE: {
      title: "Register New Asset",
      path: appRoutePath.ADD_ASSET_REGISTRY_PAGE,
      icon: navIcons.assets,
    },
    ASSET_REGISTRY_HISTORY_PAGE: {
      title: "Asset Registry History",
      path: appRoutePath.ASSET_REGISTRY_HISTORY_PAGE,
      icon: navIcons.assets,
    },
    EDIT_ASSET_REGISTRY_PAGE: {
      title: "Edit Asset",
      path: appRoutePath.EDIT_ASSET_REGISTRY_PAGE,
      icon: navIcons.assets,
    },
    ASSET_REGISTRY_DETAIL_PAGE: {
      title: "Asset Detail",
      path: appRoutePath.ASSET_REGISTRY_DETAIL_PAGE,
      icon: navIcons.assets,
    },
  },

  ASSET_DISTRIBUTION: {
    ADD_ASSET_DISTRIBUTION_PAGE: {
      title: "New Distribution",
      path: appRoutePath.ADD_ASSET_DISTRIBUTION_PAGE,
      icon: navIcons.default,
    },
    INBOUND_ASSET_DISTRIBUTIONS_PAGE: {
      title: "Inbound Distributions",
      path: appRoutePath.INBOUND_ASSET_DISTRIBUTIONS_PAGE,
      icon: navIcons.default,
    },
    INBOUND_ASSET_DISTRIBUTIONS_DETAILS_PAGE: {
      title: "Inbound Distribution Detail",
      path: appRoutePath.INBOUND_ASSET_DISTRIBUTIONS_DETAILS_PAGE,
      icon: navIcons.default,
    },
    OUTBOUND_ASSET_DISTRIBUTIONS_PAGE: {
      title: "Outbound Distributions",
      path: appRoutePath.OUTBOUND_ASSET_DISTRIBUTIONS_PAGE,
      icon: navIcons.default,
    },

    REJECTED_INBOUND_ASSET_DISTRIBUTIONS_PAGE: {
      title: "Distribution Rejections",
      path: appRoutePath.REJECTED_INBOUND_ASSET_DISTRIBUTIONS_PAGE,
      icon: navIcons.close,
    },
  },

  ASSET_DISPATCH: {
    ADD_ASSET_DISPATCH_PAGE: {
      title: "New Dispatch",
      path: appRoutePath.ADD_ASSET_DISPATCH_PAGE,
      icon: navIcons.default,
    },
    ASSET_DISPATCH_HISTORY_PAGE: {
      title: "Dispatch History",
      path: appRoutePath.ASSET_DISPATCH_HISTORY_PAGE,
      icon: navIcons.default,
    },
  },

  ASSET_ASSIGNMENT: {
    ASSET_IN_MY_POSSESSION_PAGE: {
      title: "Assets in Possession",
      path: appRoutePath.ASSET_IN_MY_POSSESSION_PAGE,
      icon: navIcons.default,
    },
    ASSET_OUTBOUND_ASSIGNMENT_HISTORY_PAGE: {
      title: "All Outbond Assignments",
      path: appRoutePath.OUTBOUND_ASSET_ASSIGNMENT_PAGE,
      icon: navIcons.default,
    },
    ASSET_INBOUND_ASSIGNMENT_HISTORY_PAGE: {
      title: "All Inbond Assignments",
      path: appRoutePath.INBOUND_ASSET_ASSIGNMENT_PAGE,
      icon: navIcons.default,
    },
    NEW_ASSET_ASSIGNMENT_PAGE: {
      title: "Assign Asset",
      path: appRoutePath.ASSET_DISTRIBUTION_READY_FOR_ASSIGNMENT_PAGE,
      icon: navIcons.default,
    },
    REJECTED_INBOUND_ASSET_ASSIGNEMENT_PAGE: {
      title: "Inbound Assignment Rejections",
      path: appRoutePath.REJECTED_INBOUND_ASSET_ASSIGNEMENT_PAGE,
      icon: navIcons.close,
    },
  },

  ASSET_REPORT: {
    ASSET_REPORT_FORM: {
      title: "Asset Report Form",
      path: appRoutePath.ASSET_REPORT_FORM,
      icon: navIcons.default,
    },
    ASSET_REPORT_HISTORY: {
      title: "Asset Report History",
      path: appRoutePath.ASSET_REPORT_HISTORY,
      icon: navIcons.default,
    },
    EDIT_ASSET_REPORT_FORM: {
      title: "Edit Report Form",
      path: appRoutePath.EDIT_ASSET_REPORT_FORM,
      icon: navIcons.default,
    },
  },

  ASSET_MAINTENANCE: {
    ASSET_MAINTENANCE_HISTORY_PAGE: {
      title: "Maintenance Schedules",
      path: appRoutePath.ASSET_MAINTENANCE_HISTORY_PAGE,
      icon: navIcons.default,
    },
    ADD_ASSET_MAINTENANCE_PAGE: {
      title: "New Maintenance",
      path: appRoutePath.ADD_ASSET_MAINTENANCE_PAGE,
      icon: navIcons.maintenance,
    },
    EDIT_ASSET_MAINTENANCE_PAGE: {
      title: "Edit Maintenance",
      path: appRoutePath.EDIT_ASSET_MAINTENANCE_PAGE,
      icon: navIcons.maintenance,
    },
  },

  SETTINGS: {
    MANAGE_DIVISIONS_PAGE: {
      title: "Divisions",
      path: appRoutePath.MANAGE_DIVISIONS_PAGE,
      icon: navIcons.divisions,
    },
    MANAGE_PROGRAMMES_PAGE: {
      title: "Programmes",
      path: appRoutePath.MANAGE_PROGRAMMES_PAGE,
      icon: navIcons.programmes,
    },
    MANAGE_FACILITIES_PAGE: {
      title: "Facilities",
      path: appRoutePath.MANAGE_FACILITIES_PAGE,
      icon: navIcons.facilities,
    },
    MANAGE_REGIONS_PAGE: {
      title: "Regions",
      path: appRoutePath.MANAGE_REGIONS_PAGE,
      icon: navIcons.regions,
    },
    MANAGE_DISTRICTS_PAGE: {
      title: "Districts",
      path: appRoutePath.MANAGE_DISTRICTS_PAGE,
      icon: navIcons.districts,
    },
    MANAGE_DONORS_PAGE: {
      title: "Donors",
      path: appRoutePath.MANAGE_DONORS_PAGE,
      icon: navIcons.donors,
    },
    MANAGE_BATCHES_PAGE: {
      title: "Batches",
      path: appRoutePath.MANAGE_BATCHES_PAGE,
      icon: navIcons.batches,
    },

    CATEGORIES: {
      MANAGE_ASSET_CATEGORIES_PAGE: {
        title: "Asset Categories",
        path: appRoutePath.MANAGE_ASSET_CATEGORIES_PAGE,
        icon: navIcons.settings,
      },
      MANAGE_ASSET_TAGS_PAGE: {
        title: "Asset Tags",
        path: appRoutePath.MANAGE_ASSET_TAGS_PAGE,
        icon: navIcons.settings,
      },
      MANAGE_USER_CATEGORIES_PAGE: {
        title: "User Categories",
        path: appRoutePath.MANAGE_USER_CATEGORIES_PAGE,
        icon: navIcons.settings,
      },
    },
  },
};
